var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9208 6.26865e-05C9.66315 0.00351915 6.53983 1.29946 4.23606 3.60291C1.93236 5.90661 0.636694 9.03 0.632965 12.2877C0.632965 15.3988 2.38737 19.5561 5.32531 23.4096C8.01518 26.9327 11.067 29.3016 12.9211 29.3016C14.7752 29.3016 17.8268 26.9329 20.5156 23.4076C23.4538 19.5549 25.2087 15.3979 25.2087 12.2876C25.2053 9.02968 23.9096 5.90661 21.6059 3.60285C19.3022 1.2994 16.1788 0.00347619 12.9211 0L12.9208 6.26865e-05ZM12.9208 19.4528V19.4531C11.0206 19.4531 9.19778 18.6981 7.85395 17.354C6.51012 16.0102 5.75516 14.1874 5.75516 12.2871C5.7554 10.3866 6.51038 8.5638 7.85421 7.21997C9.19829 5.87639 11.0208 5.12143 12.9213 5.12143C14.8219 5.12168 16.6444 5.87665 17.9882 7.22073C19.3321 8.56456 20.0868 10.3873 20.0865 12.2879C20.0843 14.1877 19.3286 16.0087 17.9853 17.352C16.6419 18.6951 14.8207 19.4508 12.9208 19.4531V19.4528Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bd1d0eacf15e5c551e5ac4444b937a7c.svg";
export { ForwardRef as ReactComponent };